/*
*   参数说明：
    title: String // 通知标题
    options: { // 其他配置项
      dir: 'auto', // 文本对齐方式（其他参数：auto【采用浏览器的语言设置行为（默认）】、ltr【左到右】、rtl【右到左】）
      icon: 'assets/img/logo-symbol.png', // 显示的图标的URL
      tag: String, // 标记当前通知的标签
      renotify: String // 新通知出现的时候是否替换之前的。如果设为true，则表示替换，表示当前标记的通知只会出现一个。注意都这里“当前标记”没？没错，true参数要想其作用，必须tag需要设置属性值
      lang: 'zh', // 语言标记（可以忽略）
      body: '通知的内容', // 通知的内容
      data: '任意类型和通知相关联的数据。',
      silent: Boolean, // 通知出现的时候，是否要有声音。默认false, 表示无声。
      sound: String // 音频地址。表示通知出现要播放的声音资源。
    },
    time: number, // number秒后关闭通知
    website: 'www.baidu.com' // 点击后跳转到百度
*/

let noticeFun = (title, options, time, website) => {
  if (!options) {
    options = {}
  }
  var notice = new Notification(title, options)
  if (website) {
    notice.onclick = function (event) {
      event.preventDefault() // 防止浏览器聚焦在通知的选项卡上。
      window.open(website, '_self')
    }
  }
  var times = 4000
  if (time) {
    times = time
  }
  setTimeout(notice.close.bind(notice), times) // 关闭时间
}

let systemNotice = (title, options, time, website) => {
  if (window.Notification) { // 浏览器支持
    if (Notification.permission === 'granted') { // 检查用户是否同意接受通知
      noticeFun(title, options, time, website)
    } else if (Notification.permission !== 'denied') { // 否则我们需要向用户获取权限
      Notification.requestPermission((permission) => { // 如果用户同意，就可以向他们发送通知
        if (permission === 'granted') {
          noticeFun(title, options, time, website)
        }
      })
    }
  }
}

export default systemNotice



// WEBPACK FOOTER //
// ./src/components-base/components-custom/systemNotice/index.js